import { createEvent, createStore, sample } from 'effector'
import { createQuery } from 'effector-apollo'
import { not } from 'patronum'

import client from 'src/apollo/client'
import { remap } from 'src/shared/lib/effector/remap'

import { DrugName } from '../api/drugInfo'
import { DRUG_INFO_QUERY, DrugRejection } from '../api/drugInfoQuery'

export const drugInfoQuery = createQuery({ document: DRUG_INFO_QUERY, client })
export const rejected = createEvent<DrugRejection>()

export const $isDrugCovered = not(
  remap(drugInfoQuery.$data, 'drugInfo.drug.isAlternativesOnly'),
)

export const $hasError = createStore(false)
  .on(drugInfoQuery.finished.failure, () => true)
  .reset(drugInfoQuery.start, drugInfoQuery.refresh)

export const $drug = drugInfoQuery.$data.map((data) =>
  data?.drugInfo?.kind === 'SingleFlatDrugConfiguration'
    ? data?.drugInfo.drug
    : null,
)

export const $alternatives = drugInfoQuery.$data.map<DrugName[]>((info) =>
  info?.drugInfo?.kind === 'SingleFlatDrugConfiguration'
    ? info.drugInfo.alternatives
    : [],
)

export const $reject = createStore<DrugRejection | null>(null)

export const $hasAlternatives = $alternatives.map((drugs) => drugs.length > 0)
export const $hasRejection = $reject.map(Boolean)

sample({
  clock: drugInfoQuery.finished.success,
  filter: ({ data }) => data.drugInfo?.kind === 'DrugRejection',
  fn: ({ data }) => data.drugInfo as DrugRejection,
  target: rejected,
})

sample({
  clock: rejected,
  target: $reject,
})
